import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularMaterialModule } from 'src/app/material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ValueFieldModule } from '@lib/modules';
import { SidePanelService } from '@lib/services';

@NgModule({
    declarations: [],
    imports: [CommonModule, AngularMaterialModule, ReactiveFormsModule, ValueFieldModule],
    exports: [AngularMaterialModule, ReactiveFormsModule, ValueFieldModule],
    providers: [SidePanelService],
})
export class SharedPeerToPeerModule {}
